export const SAVING_TRAVELERS_AND_CHECKING_AVAILABILITY =
  "Saving travelers and checking availability";
export const BOOKING_HOTEL = "Booking your hotel";
export const SAVING_CONTACT_INFO_AND_CHECKING_AVAILABILITY =
  "Saving contact information and checking availability";
export const FREEZING_PRICE = "Freezing the price";
